module.exports = __webpack_public_path__ + "img/continue_block_icon.d93a5c07.svg";